import * as z from "zod";

export const updateShopPayCapability = {
  name: "updateShopPayCapability" as const,
  /** Send only the field that changed. */
  input: z.object({
    enabled: z.boolean().optional(),
    guidance: z.string().max(2000).nullable().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
